'use strict';

angular.module('cloudBillingLegacyFrontend').controller('CbMissingContractCtrl', function () {
    
});
